import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { UserProfileView } from "@containers/userProfile/UserProfileView";

const UserProfilePage = () => {
    return (
        <AuthenticatedLayout>
            <UserProfileView />
        </AuthenticatedLayout>
    );
}

export default UserProfilePage;